module.exports = __webpack_public_path__ + "img/all_documents.3b8ae89e.svg";